import React, { useRef } from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

import { WebPlatform } from "@state/stores/types";

import { ErrorMessage } from "@components/inputs/shared";

export default observer(function CasinoSearchErrorPopup() {
	const rootStore = useRootAppStore<WebPlatform>();
	const casinoSearchStore = rootStore.casinoSearchStore;

	const containerRef = useRef<HTMLDivElement>(null);

	if (!casinoSearchStore.isErrorOpen) {
		return null;
	}

	return ReactDOM.createPortal(
		<div
			className="popup popup--search"
			onClick={() => {
				casinoSearchStore.setIsErrorOpen(false);
			}}
		>
			<div className="popup__card popup--search__card" ref={containerRef}>
				<div className="popup__body popup--search__body">
					<ul className="popup--search__list">
						<ErrorMessage
							name={"casinoSearch"}
							customErrorClassName={
								"popup--search__term popup--search__term--error message--validation field-validation-error"
							}
						/>
					</ul>
				</div>
			</div>
		</div>,
		document.body
	);
});
